import React, { useEffect } from "react";
import EventCard from "./EventCard";
import { Col, Container, Row } from "react-bootstrap";
import { getUpcomingEvents } from "../../shared/helpers";
import { useData } from "../../providers/dataProvider";
import { pageMeta } from "../../config/helmetConfig";
import { updateMetaTags } from "../../utils/metaManager";
import "./Events.css";

export default function Events() {
  const { events } = useData();
  const upcomingEvents = getUpcomingEvents(events, Number.MAX_SAFE_INTEGER);

  useEffect(() => {
    updateMetaTags(pageMeta.home);
  }, []);

  return (
    <div className="events-page-container">
      <div className="events-brick-background"></div>

      <div className="events-content-section">
        {/* Modern Header Section */}
        <div className="events-header-section">
          <Container>
            <Row className="justify-content-center">
              <Col xs={12}>
                <h1 className="events-title">Upcoming Events</h1>
                <div className="events-intro-card">
                  <p className="events-description">
                    Join us in celebrating our community! At The Style Emporium, we love
                    bringing people together through special gatherings, charity
                    fundraisers, and seasonal celebrations. Check out our upcoming
                    events and be part of something meaningful!
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Events Grid Section */}
        <div className="events-grid-section">
          <Container>
            <Row className="events-grid-container justify-content-center">
              {upcomingEvents.map((event, index) => (
                <Col
                  key={index}
                  xs={12}
                  md={6}
                  lg={4}
                  className="d-flex justify-content-center mb-4"
                >
                  <EventCard key={event.id} event={event} />
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}
